import { Grid, makeStyles, Typography } from '@material-ui/core';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import 'firebase/auth';
import firebase from 'firebase/compat/app';
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';

import { setUser } from 'store/authSlice';

const useStyles = makeStyles((theme) => ({
  fullContainer: {
    backgroundColor: theme.palette.primary.main,
    height: '100%',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(8, 28, 0),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4, 5, 0),
    },
  },
  content: {
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(12),
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(7),
    },
  },
  subtitle: {
    color: 'rgba(255, 255, 255, 0.6)',
  },
  title: {
    marginTop: theme.spacing(1),
    color: theme.palette.common.white,
  },
  description: {
    marginTop: theme.spacing(2),
    maxWidth: 485,
    color: theme.palette.common.white,
  },
  login: {
    marginTop: theme.spacing(9),
  },
  contact: {
    marginTop: theme.spacing(2),
    color: theme.palette.common.white,
  },
  footer: {
    position: 'absolute',
    bottom: theme.spacing(3),
    color: theme.palette.common.white,
  },
}));

function Login() {
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    firebase.auth().onAuthStateChanged(user => {
      if (!user) {
        const ui =
          firebaseui.auth.AuthUI.getInstance() ||
          new firebaseui.auth.AuthUI(firebase.auth());
        ui.start('#firebaseui-auth-container', {
          callbacks: {
            signInSuccessWithAuthResult: function (authResult, redirectUrl) {},
          },
          signInFlow: 'popup',
          signInOptions: [
            // List of OAuth providers supported.
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            {
              provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
              requireDisplayName: false,
            },
          ],
        });
      } else {
        // quick fix to avoid storing non-serializable objects in store
        const userWithoutFunctions = JSON.parse(JSON.stringify(user));
        dispatch(setUser(userWithoutFunctions));
      }
    });
  });

  return (
    <Grid
      container
      className={classes.fullContainer}
      direction='column'
      justifyContent='flex-start'
      alignItems='flex-start'
    >
      <Grid item container direction='column' className={classes.content}>
        <Grid item className={classes.subtitle}>
          <Typography variant='subtitle1' color='inherit'>
            Thinking Machines
          </Typography>
        </Grid>
        <Grid item className={classes.title}>
          <Typography variant='h3' color='inherit'>
            ALI Carbon Forest
          </Typography>
        </Grid>

        <Grid item className={classes.login}>
          <div id='firebaseui-auth-container' />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Login;
